import { RSAA } from "../middlewares/redux-api-middleware";
import { normalize } from "normalizr";

import { API, EXPOSITIONS_PER_PAGE } from "../config";
import {
  EXPOSITION_PREVIEWS,
  EXPOSITION_ITEM,
  EXPOSITION_KIND_ACTUAL,
} from "../constants/expositionConstants";
import {
  expositionPreviewSchema,
  expositionSchema
} from "../schemas";
import { FUNC_REPLACE } from "../reducers/entities/collectionsReducer";


export function fetchItems(kind = EXPOSITION_KIND_ACTUAL, page = 1, perPage = EXPOSITIONS_PER_PAGE, fetchOptions = {}) {
  const meta = {
    collection: fetchOptions.collection || kind,
    func: FUNC_REPLACE, // page === 1 ? FUNC_REPLACE : FUNC_APPEND,
  };

  return function fetchItemsThunk(dispatch) {
    return dispatch({
      [RSAA]: {
        endpoint: `${API}/expositions?kind=${kind}&page=${page}&per_page=${perPage}`,
        types: EXPOSITION_PREVIEWS.types({
          all: { meta },
          success: {
            payload: parseResponse,
          },
          failed: {
            payload: errorHandler
          }
        }),
      }
    });

    async function errorHandler(action, state, res) {
      return {};
    }

    async function parseResponse(action, state, res) {
      const { expositions, meta } = await res.json();

      return {
        ...normalize(expositions, [expositionPreviewSchema]),
        pagination: meta,
      };
    }
  };
}


export function fetchItem(id, fetchOptions = {}) {
  const meta = {
    key: id,
  };
  const include = fetchOptions.include || {};

  return function fetchItemThunk(dispatch) {
    return dispatch({
      [RSAA]: {
        endpoint: `${API}/expositions/${id}`,
        types: EXPOSITION_ITEM.types({
          all: { meta },
          success: {
            payload: parseResponse,
          },
          failed: {
            payload: errorHandler
          }
        }),
      }
    });

    async function errorHandler(action, state, res) {
      return {};
    }

    async function parseResponse(action, state, res) {
      const { exposition } = await res.json();

      return {
        ...normalize(exposition, expositionSchema),
      }
    }
  }
}
